import { Body1, Image, UIHeading3 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC } from 'react';

import { AdLabel } from 'shared/components/AdLabel';
import { MortgageAnnotations } from 'shared/components/MortgageAnnotations';
import { Ticker } from 'shared/components/Ticker';

import { TGetTgbNativedescGeneralCompleteContextResult } from '../../../../utils/getTgbNativedescGeneralCompleteContext';

import styles from './TgbNativedescGeneralDesktopCard.css';

export type TTgbNativedescGeneralDesktopCardProps = {
  completeContext: TGetTgbNativedescGeneralCompleteContextResult;
};

export const TgbNativedescGeneralDesktopCard: FC<TTgbNativedescGeneralDesktopCardProps> = ({
  completeContext: {
    title,
    annotation,
    image,
    url,
    label,
    logoImageUrl,
    description,
    sizes,
    mortgageTermsWarning,
    mortgageWarning,
  },
}) => {
  const withMortgageAnnotations = !!(mortgageWarning || mortgageTermsWarning);

  return (
    <a
      data-testid="tgb-nativedesc-general-desktop-card"
      href={url}
      target="_blank"
      className={clsx(styles['container'], withMortgageAnnotations && styles['container-with-mortgage-annotations'])}
      rel="noopener noreferrer"
      style={sizes}
    >
      <div className={styles['content']}>
        <div className={styles['title-container']}>
          <UIHeading3>{title}</UIHeading3>
          {!!description && <Body1>{description}</Body1>}
        </div>
        {!!logoImageUrl && (
          <div className={styles['logo-container']}>
            <Image src={logoImageUrl} borderRadius="4px" width={60} height={60} objectFit="contain" />
          </div>
        )}
      </div>
      {withMortgageAnnotations && (
        <div className={styles['mortgage-annotations']}>
          <MortgageAnnotations
            splitMortgageTermsWarning
            height={sizes.height}
            mortgageTermsWarning={mortgageTermsWarning}
            mortgageWarning={mortgageWarning}
          />
        </div>
      )}
      <div className={styles['photo-block']} style={{ backgroundImage: `url(${image})` }}>
        {!!label && (
          <div className={styles['photo-label']}>
            <AdLabel label={label} />
          </div>
        )}
        {!!annotation && (
          <div className={styles['annotation']}>
            <Ticker theme="dark-background" text={annotation} />
          </div>
        )}
      </div>
    </a>
  );
};
